import { render, staticRenderFns } from "./UploadSims.vue?vue&type=template&id=3e54c3f2&"
import script from "./UploadSims.vue?vue&type=script&lang=js&"
export * from "./UploadSims.vue?vue&type=script&lang=js&"
import style0 from "./UploadSims.vue?vue&type=style&index=0&id=3e54c3f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports